import { ColumnMapDefinition } from './columnMapDefinition';
import DatabaseType, { DatabaseConnector, DataConnector, DataConnectorType, ExcelDataConnector, FeatherDataConnector, FileDataConnector, FileDataConnectorInfo, MySqlDataConnector, OracleDataConnector, ParquetDataConnector, VerticaDataConnector } from './dataConnector';
import { DataFarmType } from './dataFarmType';
import { v4 as uuidv4 } from 'uuid';

export class DataConnectorMapping {
    guid: string;
    id: number;
    name: string;
    targetDataFarm?: DataFarmType = null;
    dataConnector?: DataConnector = null;
    columnMap?: ColumnMapDefinition[];
    masterColumnMapGuid?: string; // Points to another DataConnectorMapping so we can sync columnMap
    refineryConfigGuid?: string = null;
    nodeID?: string = null;
    nodeName?: string = null;
    nodeType?: string = null;
    isMultiTabIngest?: boolean;
    excelTurboMode?: boolean;
    ingestAll?: boolean;
    sampleStart?: number;
    sampleEnd?: number;
    static fromJSON(data: any): DataConnectorMapping {
      //console.log(`fromJson invoked: ${data}`);
      const instance: DataConnectorMapping = Object.assign(new DataConnectorMapping(0, '', DataFarmType.subTask), data);

      if (instance.dataConnector?.dataConnectorType === DataConnectorType.Text) {
        instance.dataConnector = FileDataConnector.fromJSON(instance.dataConnector);
      } else if (instance.dataConnector?.dataConnectorType === DataConnectorType.Excel) {
        instance.dataConnector = ExcelDataConnector.fromJSON(instance.dataConnector);
      }else if (instance.dataConnector?.dataConnectorType === DataConnectorType.Feather) {
        instance.dataConnector = FeatherDataConnector.fromJSON(instance.dataConnector);
      }else if (instance.dataConnector?.dataConnectorType === DataConnectorType.Parquet) {
        instance.dataConnector = ParquetDataConnector.fromJSON(instance.dataConnector);
      }
      else if (instance.dataConnector?.dataConnectorType === DataConnectorType.Database) {
        if(instance.dataConnector.databaseType===DatabaseType.SQL){
          instance.dataConnector = DatabaseConnector.fromJSON(instance.dataConnector);
        }else if(instance.dataConnector.databaseType===DatabaseType.Oracle){
          instance.dataConnector = OracleDataConnector.fromJSON(instance.dataConnector);
        }
        else if(instance.dataConnector.databaseType===DatabaseType.MySql){
          instance.dataConnector = MySqlDataConnector.fromJSON(instance.dataConnector);
        }
        else if(instance.dataConnector.databaseType===DatabaseType.Vertica){
          instance.dataConnector = VerticaDataConnector.fromJSON(instance.dataConnector);
        }
        
      }
      const columnMap: ColumnMapDefinition[] = [];
      instance.columnMap?.forEach(colMap => {
          columnMap.push(ColumnMapDefinition.fromJSON(colMap));
      });
      instance.columnMap = columnMap;

      return instance;
    }

    public getFileDataConnector(): FileDataConnectorInfo {
      return this.dataConnector as FileDataConnectorInfo;
    }

    constructor(
      id: number,
      name: string,
      targetDataFarm: DataFarmType,
      dataConnector?: DataConnector,
      columnMap?: ColumnMapDefinition[],
      guid?: string,
      masterColumnMapGuid?: string,
      refineryConfigGuid?: string,
      nodeID?: string,
      nodeName?: string,
      nodeType?:string,
      isMultiTabIngest?: boolean,
      excelTurboMode?: boolean,
      ingestAll?: boolean,
      sampleStart?: number,
      sampleEnd?: number) {

      this.guid = guid ?? uuidv4();
      this.id = id;
      this.name = name;
      this.targetDataFarm = targetDataFarm;
      this.dataConnector = dataConnector;
      this.columnMap = columnMap;
      this.masterColumnMapGuid = masterColumnMapGuid;
      this.refineryConfigGuid = refineryConfigGuid;
      this.nodeID = nodeID;
      this.nodeName = nodeName;
      this.nodeType = nodeType;
      this.isMultiTabIngest = isMultiTabIngest;
      this.excelTurboMode = excelTurboMode;
      this.ingestAll = ingestAll;
      this.sampleStart = sampleStart;
      this.sampleEnd = sampleEnd;
    }

}
